<template>
  <b-container fluid>
    <h1>
      <span v-translate="{countdown}">Summary <small>(Autorefresh in %{countdown}s)</small></span>
    </h1>
    <b-card no-body class="filters">
      <b-tabs card v-model="tabIndex">
        <b-tab :title="$gettext('Shippings')" active>
          <b-row>
            <b-col>
              <b-row>
                <b-col cols="3">
                  <p>
                    <b-form-checkbox
                      id="all-statuses"
                      v-model="allStatuses"
                      :value="true"
                      :unchecked-value="false"
                    >
                      <translate>Show all statuses</translate>
                    </b-form-checkbox>
                    <b-form-checkbox
                      id="filter-by-cut-time"
                      v-model="filterByCutTime"
                      :value="true"
                      :unchecked-value="false"
                    >
                    <translate>Before Cut Hour only</translate>
                    </b-form-checkbox>
                  </p>
                </b-col>
                <b-col cols="3">
                  <p>
                    <b-form-checkbox
                      id="working-on-sat"
                      v-model="workingOnSat"
                      :value="1"
                      :unchecked-value="0"
                    >
                      <translate>Working on Saturday</translate>
                    </b-form-checkbox>
                    <b-form-checkbox
                      id="working-on-sun"
                      v-model="workingOnSun"
                      :value="1"
                      :unchecked-value="0"
                    >
                      <translate>Working on Sunday</translate>
                    </b-form-checkbox>
                  </p>
                </b-col>
                <b-col v-if="!$cookies.get('bypassCountry') && warehousesSelect.length > 0" cols="3">
                  <b-form-group>
                    <label for="filter-warehouse" v-translate>Select Origin Warehouse</label>
                    <b-form-select v-model="filterWarehouse" :options="warehousesSelect">
                      <template slot="first">
                        <option :value="null" v-translate>None</option>
                      </template>
                    </b-form-select>
                  </b-form-group>
                </b-col>
              </b-row>
              <label for="inline-form-input-name">
                <span v-translate>Date Range <em>(120 days max.)</em></span>
              </label>
              <label v-show="updatedDateRangeActive !== 0">&nbsp;[<a href="#" @click.prevent="resetupdatedDateRange" v-translate>reset range</a>]</label>
              <date-range-picker
                v-if="this.locale.daysOfWeek"
                v-model="updatedDateRange"
                :locale-data="locale"
                :opens="opens"
                class="mb-2 w-100"
                :ranges="ranges"
                :min-date="minDate"
                @update="updateValues"
              >
                <div slot="input" slot-scope="picker">
                  <font-awesome-icon :icon="['far', 'calendar-alt']" size="1x" style="vertical-align: middle" />
                  <span v-if="updatedDateRangeActive === 0" style="vertical-align: middle" v-translate>Last 7 days</span>
                  <span v-else style="vertical-align: middle">{{moment(updatedDateRange.startDate).format('L')}} - {{moment(updatedDateRange.endDate).format('L')}}</span>
                </div>
              </date-range-picker>
            </b-col>
          </b-row>
          <b-card class="p-0">
            <b-row>
              <b-col v-for="(total, i) in totals" :key="i" cols="3">
                <h6><b-link target="_blank" :href="'/list/shippings/manual?qs=' + makeLink([i])">{{ i }}</b-link> <b-badge :variant="total > 0 ? 'secondary' : 'dark'"><span class="big">{{total}}</span></b-badge></h6>
              </b-col>
              <b-col cols="3">
                <h6>
                  <translate>Moovers</translate>
                  <b-badge :variant="workedCouriers > 0 ? 'secondary' : 'dark'"><span class="big">{{workedCouriers}}</span></b-badge>
                </h6>
              </b-col>
              <b-col cols="3">
                <h6><b-link target="_blank" :href="'/list/shippings/manual?qs=%7B%22statuses%22%3A%5B%5D%2C%22types%22%3A%5B%5D%2C%22scheduleds%22%3A%5B%5D%2C%22scheduledsToday%22%3A%5B%5D%2C%22shippingId%22%3A%5B%5D%2C%22destinationContactName%22%3A%5B%5D%2C%22originAddress%22%3A%5B%5D%2C%22destinationAddress%22%3A%5B%5D%2C%22externalCode%22%3A%5B%5D%2C%22withoutTour%22%3A%5B%5D%2C%22company%22%3A%5B%5D%2C%22courier%22%3A%5B%5D%2C%22client%22%3A%5B%5D%2C%22forReview%22%3A%5B%22fields_revision%22%2C%22eq%22%2C1%5D%2C%22readyWithIncidence%22%3A%5B%5D%2C%22needUrgentAction%22%3A%5B%22first_ready_date%22%2C%22eq%22%2C%22NULL%22%2C%20true%5D%2C%20%22needUrgentActionStatuses%22%3A%5B%22status%22%2C%20%22eq%22%2C%20%22DRAFT%22%5D%2C%22createdAtFrom%22%3A%5B%22created_at%22%2C%22gte%22%2C%22' + utcDateFrom.utc().format('YYYY-MM-DD HH:mm:ss') + '%22%5D%2C%22createdAtTo%22%3A%5B%22created_at%22%2C%22lte%22%2C%22' + utcDateTo.utc().format('YYYY-MM-DD HH:mm:ss') + '%22%5D%2C%22updatedAtFrom%22%3A%5B%5D%2C%22updatedAtTo%22%3A%5B%5D%7D'" v-translate>Need URGENT action</b-link> <b-badge :variant="needUrgentAction > 0 ? 'danger' : 'dark'"><span class="big">{{needUrgentAction}}</span></b-badge></h6>
              </b-col>
              <b-col cols="3">
                <h6><b-link target="_blank" :href="'/list/shippings/manual?qs=%7B%22statuses%22%3A%5B%22status%22%2C%22in%22%2C%5B%22CONFIRMED%22%2C%22ATPICKUPPOINT%22%2C%22INTRANSIT%22%2C%22INCIDENCE%22%5D%5D%2C%22types%22%3A%5B%22shipping_type_id%22%2C%22in%22%2C%5B' + flexesTypeId + '%5D%5D%2C%22scheduleds%22%3A%5B%5D%2C%22shippingId%22%3A%5B%5D%2C%22destinationContactName%22%3A%5B%5D%2C%22destinationAddress%22%3A%5B%5D%2C%22externalCode%22%3A%5B%5D%2C%22withoutTour%22%3A%5B%5D%2C%22company%22%3A%5B%5D%2C%22courier%22%3A%5B%5D%2C%22client%22%3A%5B%5D%2C%22forReview%22%3A%5B%5D%2C%22createdAtTo%22%3A%5B%5D%2C%22createdAtFrom%22%3A%5B%5D%2C%22updatedAtFrom%22%3A%5B%22updated_at%22%2C%22gte%22%2C%22' + utcMeliStalledDateFrom.utc().format('YYYY-MM-DD HH:mm:ss') + '%22%5D%2C%22updatedAtTo%22%3A%5B%22updated_at%22%2C%22lte%22%2C%22' + utcMeliStalledDateTo.utc().format('YYYY-MM-DD HH:mm:ss') + '%22%5D%7D'" v-translate>MELI Stalled</b-link> <b-badge :variant="meliStalled > 0 ? 'danger' : 'dark'"><span class="big">{{meliStalled}}</span></b-badge></h6>
              </b-col>
              <b-col cols="3">
                <h6><b-link target="_blank" :href="'/list/shippings/manual?qs=%7B%22statuses%22%3A%5B%22status%22%2C%22in%22%2C%5B%22CONFIRMED%22%2C%22ATPICKUPPOINT%22%2C%22INTRANSIT%22%2C%22INCIDENCE%22%2C%22TOBERETURNED%22%5D%5D%2C%22types%22%3A%5B%22shipping_type_id%22%2C%22in%22%2C%5B' + notFlexesTypeId + '%5D%5D%2C%22scheduleds%22%3A%5B%5D%2C%22shippingId%22%3A%5B%5D%2C%22destinationContactName%22%3A%5B%5D%2C%22destinationAddress%22%3A%5B%5D%2C%22externalCode%22%3A%5B%5D%2C%22withoutTour%22%3A%5B%5D%2C%22company%22%3A%5B%5D%2C%22courier%22%3A%5B%5D%2C%22client%22%3A%5B%5D%2C%22forReview%22%3A%5B%5D%2C%22createdAtTo%22%3A%5B%5D%2C%22createdAtFrom%22%3A%5B%5D%2C%22updatedAtFrom%22%3A%5B%22updated_at%22%2C%22gte%22%2C%22' + utcGeneralStalledDateFrom.utc().format('YYYY-MM-DD HH:mm:ss') + '%22%5D%2C%22updatedAtTo%22%3A%5B%22updated_at%22%2C%22lte%22%2C%22' + utcGeneralStalledDateTo.utc().format('YYYY-MM-DD HH:mm:ss') + '%22%5D%7D'" v-translate>General Stalled</b-link> <b-badge :variant="generalStalled > 0 ? 'danger' : 'dark'"><span class="big">{{generalStalled}}</span></b-badge></h6>
              </b-col>
            </b-row>
          </b-card>
          <b-row>
            <b-col md="3" v-for="(company, index) in summary" :key="index" v-if="((!allStatuses && (company.statuses.READY || company.statuses.DRAFT || company.statuses.READYATSTORE)) || allStatuses)">
              <b-card>
                <b-card-title class="mb-1">
                  <input type="checkbox"
                    class="mr-2"
                    v-model="companiesCollection"
                    :value="{company_id: company.company_id, name: company.name}"
                    v-if="company.name && !allStatuses"
                  />
                  <a :href="'/edit/companies/' + company.company_id" target="_blank">{{company.name}}</a>
                </b-card-title>
                <b-card-text>
                  <div class="mb-2" v-if="company.operators || company.cut_time">
                    <b-badge pill variant="info" v-translate="{data: moment(company.cut_time).format('L LT')}">Cut time %{data} hs</b-badge>
                    <b-badge pill v-for="(operator, index) in company.operators" :key="index" v-if="company.operators">
                      {{ operator.name }}
                    </b-badge>
                  </div>
                  <b-row v-if="company.schedule_for && company.schedule">
                    <b-col>
                      <hr class="mt-0 mb-1">
                      <dl class="mb-0">
                        <dt v-translate="{data: $gettext(company.schedule_for)}">Schedule for %{data}</dt>
                        <dd class="mb-0" v-if="company.schedule">
                          <span v-if="company.schedule[0]">
                            {{ company.schedule[0].from }}
                            {{ company.schedule[0].to ? ' to ' + company.schedule[0].to : ''}}
                          </span>
                          <span v-if="company.schedule[1]">
                            {{ company.schedule[0] ? ' and ' : '' }}
                            {{ company.schedule[1].from ? company.schedule[1].from : '' }}
                            {{ company.schedule[1].to ? ' to ' + company.schedule[1].to : ''}}
                          </span>
                        </dd>
                      </dl>
                      <hr class="my-1">
                    </b-col>
                  </b-row>
                  <div v-for="(status, i) in company.statuses" :key="i" v-if="(!allStatuses && (i === 'READY' || i === 'DRAFT' || i === 'READYATSTORE')) || allStatuses">
                    <b-link target="_blank" :href="'/list/shippings/manual?qs=' + makeLink([i], [company.company_id], [company.name])" v-if="company.company_id">{{ i }}</b-link>
                    <span v-else>{{ i }}</span>
                    <b-badge>{{status}}</b-badge>
                  </div>
                </b-card-text>
              </b-card>
            </b-col>
          </b-row>
          <b-row v-if="companiesCollection.length">
            <b-col class="text-center">
              <b-button target="_blank" :href="'/list/shippings/manual?qs=' + collectionQs" v-translate>Open Listing with selected</b-button>
            </b-col>
          </b-row>
        </b-tab>
        <b-tab :title="$gettext('Scheduleds for today')">
          <b-row>
            <b-col cols="3">
              <b-form-checkbox
                id="pending-only"
                v-model="pendingOnly"
                :value="true"
                :unchecked-value="false"
                class="mb-3"
              >
                <translate>Show PENDING ONLY (from now to end of the day)</translate>
              </b-form-checkbox>
            </b-col>
            <b-col v-if="!$cookies.get('bypassCountry') && warehousesSelect.length > 0" cols="3">
              <b-form-group>
                <label for="filter-warehouse" v-translate>Select Origin Warehouse</label>
                <b-form-select v-model="filterWarehouse" :options="warehousesSelect">
                  <template slot="first">
                    <option :value="null" v-translate>None</option>
                  </template>
                </b-form-select>
              </b-form-group>
            </b-col>
          </b-row>
          <b-card class="p-0">
            <b-row>
              <b-col v-for="(total, i) in totalsScheduleds" :key="i" cols="3">
                <h6><b-link target="_blank" :href="'/list/shippings/manual?qs=' + makeScheduledsLink([i])">{{ i }}</b-link> <b-badge :variant="total > 0 ? 'secondary' : 'dark'"><span class="big">{{total}}</span></b-badge></h6>
              </b-col>
            </b-row>
          </b-card>
          <b-row>
            <b-col md="3" v-for="(company, index) in scheduleds" :key="index" v-if="((!allStatuses && (company.statuses.READY || company.statuses.DRAFT)) || allStatuses)">
              <b-card>
                <b-card-title><input type="checkbox"
                  class="mr-2"
                  v-model="companiesScheduledsCollection"
                  :value="{company_id: company.company_id, name: company.name}"
                />{{company.name || $gettext('Particulars')}}</b-card-title>
                <b-card-text>
                  <div v-for="(status, i) in company.statuses" :key="i" v-if="i === 'READY' || i === 'DRAFT'">
                    <b-link target="_blank" :href="'/list/shippings/manual?qs=' + makeScheduledsLink([i], [company.company_id], [company.name])" v-if="company.company_id">{{ i }}</b-link>
                    <span v-else>{{ i }}</span>
                    <b-badge>{{status}}</b-badge>
                  </div>
                </b-card-text>
              </b-card>
            </b-col>
          </b-row>
          <b-row v-if="companiesScheduledsCollection.length">
            <b-col class="text-center">
              <b-button target="_blank" :href="'/list/shippings/manual?qs=' + collectionScheduledsQs" v-translate>Open Listing with selected</b-button>
            </b-col>
          </b-row>
        </b-tab>
        <b-tab :title="$gettext('Up to today at Cut Hour')">
          <b-row>
            <b-col cols="3" lg="2">
              <b-form-group v-if="!$cookies.get('bypassCountry') && warehousesSelect.length > 0" class="mb-3">
                <label for="filter-warehouse" v-translate>Select Origin Warehouse</label>
                <b-form-select v-model="filterWarehouse" :options="warehousesSelect">
                  <template slot="first">
                    <option :value="null" v-translate>None</option>
                  </template>
                </b-form-select>
              </b-form-group>
              <b-form-checkbox-group
                id="checkbox-group-1"
                v-model="flexesTypeId"
                :options="shippingTypesSelect"
                stacked
              ></b-form-checkbox-group>
            </b-col>
            <b-col>
              <b-card class="p-0">
                <b-row>
                  <b-col v-for="(total, i) in totalsFlexes" :key="i" cols="3">
                    <h6><b-link target="_blank" :href="'/list/shippings/manual?qs=' + makeFlexesLink([i])">{{ i }}</b-link> <b-badge :variant="total > 0 ? 'secondary' : 'dark'"><span class="big">{{total}}</span></b-badge></h6>
                  </b-col>
                </b-row>
              </b-card>
              <b-row>
                <b-col md="3" v-for="(company, index) in flexes" :key="index" v-if="((!allStatuses && (company.statuses.READY || company.statuses.DRAFT)) || allStatuses)">
                  <b-card>
                    <b-card-title><input type="checkbox"
                      class="mr-2"
                      v-model="companiesFlexesCollection"
                      :value="{company_id: company.company_id, name: company.name}"
                    />{{company.name || $gettext('Particulars')}}</b-card-title>
                    <b-card-text>
                      <div v-for="(status, i) in company.statuses" :key="i" v-if="i === 'READY' || i === 'DRAFT'">
                        <b-link target="_blank" :href="'/list/shippings/manual?qs=' + makeFlexesLink([i], [company.company_id], [company.name])" v-if="company.company_id">{{ i }}</b-link>
                        <span v-else>{{ i }}</span>
                        <b-badge>{{status}}</b-badge>
                      </div>
                    </b-card-text>
                  </b-card>
                </b-col>
              </b-row>
              <b-row v-if="companiesFlexesCollection.length">
                <b-col class="text-center">
                  <b-button target="_blank" :href="'/list/shippings/manual?qs=' + collectionFlexesQs" v-translate>Open Listing with selected</b-button>
                </b-col>
              </b-row>
            </b-col>
          </b-row>
        </b-tab>
        <b-tab :title="$gettextInterpolate($gettext('SLA Next Day for %{date}'), {date: moment.utc().tz($tz).add(1, 'day').format('L')})">
          <b-row>
            <b-col cols="3" lg="2">
              <b-form-group v-if="!$cookies.get('bypassCountry') && warehousesSelect.length > 0" class="mb-3">
                <label for="filter-warehouse" v-translate>Select Origin Warehouse</label>
                <b-form-select v-model="filterWarehouse" :options="warehousesSelect">
                  <template slot="first">
                    <option :value="null" v-translate>None</option>
                  </template>
                </b-form-select>
              </b-form-group>
              <b-form-checkbox-group
                id="checkbox-group-1"
                v-model="nextDaysTypeId"
                :options="shippingTypesSelect"
                stacked
              ></b-form-checkbox-group>
            </b-col>
            <b-col>
              <b-card class="p-0">
                <b-row>
                  <b-col v-for="(total, i) in totalsNextDays" :key="i" cols="3">
                    <h6><b-link target="_blank" :href="'/list/shippings/manual?qs=' + makeNextDaysLink([i])">{{ i }}</b-link> <b-badge :variant="total > 0 ? 'secondary' : 'dark'"><span class="big">{{total}}</span></b-badge></h6>
                  </b-col>
                </b-row>
              </b-card>
              <b-row>
                <b-col md="3" v-for="(company, index) in nextDays" :key="index" v-if="((!allStatuses && (company.statuses.READY || company.statuses.DRAFT)) || allStatuses)">
                  <b-card>
                    <b-card-title><input type="checkbox"
                      class="mr-2"
                      v-model="companiesNextDaysCollection"
                      :value="{company_id: company.company_id, name: company.name}"
                    />{{company.name || 'Particulars'}}</b-card-title>
                    <b-card-text>
                      <div v-for="(status, i) in company.statuses" :key="i" v-if="i === 'READY' || i === 'DRAFT'">
                        <b-link target="_blank" :href="'/list/shippings/manual?qs=' + makeNextDaysLink([i], [company.company_id], [company.name])" v-if="company.company_id">{{ i }}</b-link>
                        <span v-else>{{ i }}</span>
                        <b-badge>{{status}}</b-badge>
                      </div>
                    </b-card-text>
                  </b-card>
                </b-col>
              </b-row>
              <b-row v-if="companiesNextDaysCollection.length">
                <b-col class="text-center">
                  <b-button target="_blank" :href="'/list/shippings/manual?qs=' + collectionNextDaysQs" v-translate>Open Listing with selected</b-button>
                </b-col>
              </b-row>
            </b-col>
          </b-row>
        </b-tab>
        <b-tab :title="$gettext('Street')">
          <b-row>
            <b-col cols="3" lg="2">
              <b-form-group>
                <label class="" for="inline-form-input-name" v-translate>Date Range <em>(120 days max.)</em></label><label v-show="updatedDateRangeActive !== 0">&nbsp;[<a href="#" @click.prevent="resetupdatedDateRangeStreet" v-translate>reset range</a>]</label>
                <date-range-picker
                  v-if="this.locale.daysOfWeek"
                  v-model="updatedDateRange"
                  :locale-data="locale"
                  :opens="opens"
                  class="mb-2 w-100"
                  :ranges="ranges"
                  :min-date="minDate"
                  @update="updateValues"
                >
                  <div slot="input" slot-scope="picker">
                    <font-awesome-icon :icon="['far', 'calendar-alt']" size="1x" style="vertical-align: middle" />
                    <span v-if="updatedDateRangeActive === 0" style="vertical-align: middle" v-translate>Today</span>
                    <span v-else style="vertical-align: middle">{{moment(updatedDateRange.startDate).format('L')}} - {{moment(updatedDateRange.endDate).format('L')}}</span>
                  </div>
                </date-range-picker>
              </b-form-group>
              <b-form-checkbox-group
                id="checkbox-group-1"
                v-model="flexiblesTypeId"
                :options="shippingTypesSelect"
                stacked
              ></b-form-checkbox-group>
            </b-col>
            <b-col>
              <b-card class="p-0">
                <b-row>
                  <b-col v-for="(total, i) in totalsFlexibles" :key="i" cols="3">
                    <h6><b-link target="_blank" :href="'/list/shippings/manual?qs=' + makeFlexiblesLink([i])">{{ i }}</b-link> <b-badge :variant="total > 0 ? 'secondary' : 'dark'"><span class="big">{{total}}</span></b-badge></h6>
                  </b-col>
                </b-row>
              </b-card>
              <b-row>
                <b-col md="3" v-for="(company, index) in flexibles" :key="index" v-if="((!allStatuses && (company.statuses.READY || company.statuses.WAITING || company.statuses.DRAFT)) || allStatuses)">
                  <b-card>
                    <b-card-title><input type="checkbox"
                      class="mr-2"
                      v-model="companiesFlexiblesCollection"
                      :value="{company_id: company.company_id, name: company.name}"
                    />{{company.name || $gettext('Particulars')}}</b-card-title>
                    <b-card-text>
                      <div v-for="(status, i) in company.statuses" :key="i" v-if="i === 'READY' || i === 'WAITING'">
                        <b-link target="_blank" :href="'/list/shippings/manual?qs=' + makeFlexiblesLink([i], [company.company_id], [company.name])" v-if="company.company_id">{{ i }}</b-link>
                        <span v-else>{{ i }}</span>
                        <b-badge>{{status}}</b-badge>
                      </div>
                    </b-card-text>
                  </b-card>
                </b-col>
              </b-row>
              <b-row v-if="companiesFlexiblesCollection.length">
                <b-col class="text-center">
                  <b-button target="_blank" :href="'/list/shippings/manual?qs=' + collectionFlexiblesQs" v-translate>Open Listing with selected</b-button>
                </b-col>
              </b-row>
            </b-col>
          </b-row>
        </b-tab>
      </b-tabs>
    </b-card>
  </b-container>
</template>

<script>
import DateRangePicker from 'vue2-daterange-picker'
import UserCard from '@/components/UserCard'

export default {
  components: {
    DateRangePicker,
    UserCard
  },
  data() {
    return {
      tabIndex: 0,
      summary: [],
      totals: {},
      companiesCollection: [],
      collectionQs: '',
      utcDateFrom: null,
      utcDateTo: null,
      date_from: this.moment().subtract(6, 'day').startOf('day'),
      date_to: this.moment().subtract(0, 'day').endOf('day'),
      updatedDateRange: { // used for v-model prop
        startDate: this.moment().subtract(6, 'day').startOf('day').toDate(),
        endDate: this.moment().subtract(0, 'day').endOf('day').toDate()
      },
      opens: 'right', //  which way the picker opens, default "center", can be "left"/"right"
      locale: {
        direction: 'ltr', //  direction of text
        format: 'dd/mm/yyyy', //  fomart of the dates displayed
        separator: ' - ', //  separator between the two ranges
        applyLabel: this.$gettext('Apply'),
        cancelLabel: this.$gettext('Cancel'),
        weekLabel: 'W',
        customRangeLabel: this.$gettext('Custom Range'),
        daysOfWeek: this.moment.weekdaysMin(), // days, //  array of days - see moment documenations for details
        monthNames: this.moment.monthsShort(), //  array of month names - see moment documenations for details
        firstDay: 1,
        showWeekNumbers: false //  show week numbers on each row of the calendar
      },
      ranges: { //  default value for ranges object (if you set this to false ranges will no be rendered)
        [this.$gettext('Today')]: [this.moment().toDate(), this.moment().toDate()],
        [this.$gettext('Yesterday')]: [this.moment().subtract(1, 'days').toDate(), this.moment().subtract(1, 'days').toDate()],
        [this.$gettext('Last 7 days')]: [this.moment().subtract(6, 'day').startOf('day').toDate(), this.moment().subtract(0, 'day').endOf('day').toDate()],
        [this.$gettext('Last 30 days')]: [this.moment().subtract(29, 'day').startOf('day').toDate(), this.moment().subtract(0, 'day').endOf('day').toDate()],
        [this.$gettext('Last 120 days')]: [this.moment().subtract(120, 'day').startOf('day').toDate(), this.moment().subtract(0, 'day').endOf('day').toDate()],
        [this.$gettext('This month')]: [this.moment().startOf('month').toDate(), this.moment().endOf('month').toDate()],
        // [this.$gettext('This year')]: [this.moment().startOf('year'), this.moment().endOf('year')],
        [this.$gettext('Last week')]: [this.moment().subtract(1, 'week').startOf('week').toDate(), this.moment().subtract(1, 'week').endOf('week').toDate()],
        [this.$gettext('Last month')]: [this.moment().subtract(1, 'month').startOf('month').toDate(), this.moment().subtract(1, 'month').endOf('month').toDate()]
      },
      updatedDateRangeActive: 0,
      minDate: '',
      maxDate: this.moment().format('YYYY-MM-DD'),
      allStatuses: false,
      filterByCutTime: false,
      intervalSummary: null,
      intervalCountdown: null,
      countdown: 60,
      scheduleds: [],
      totalsScheduleds: {},
      companiesScheduledsCollection: [],
      collectionScheduledsQs: '',
      pendingOnly: false,
      workedCouriers: 0,
      flexes: [],
      totalsFlexes: {},
      companiesFlexesCollection: [],
      collectionFlexesQs: '',
      flexesTypeId: [],
      notFlexesTypeId: [],
      needUrgentAction: null,
      meliStalled: null,
      utcMeliStalledDateFrom: null,
      utcMeliStalledDateTo: null,
      generalStalled: null,
      utcGeneralStalledDateFrom: null,
      utcGeneralStalledDateTo: null,
      filterByOperator: {},
      workingOnSat: 0,
      workingOnSun: 0,
      filterWarehouse: null,
      nextDaysTypeId: [],
      totalsNextDays: {},
      nextDays: [],
      companiesNextDaysCollection: [],
      collectionNextDaysQs: '',
      flexiblesTypeId: [],
      totalsFlexibles: {},
      flexibles: [],
      companiesFlexiblesCollection: [],
      collectionFlexiblesQs: '',
      weekdaysShort: [
        this.$gettext('Sun'),
        this.$gettext('Mon'),
        this.$gettext('Tue'),
        this.$gettext('Wed'),
        this.$gettext('Thu'),
        this.$gettext('Fri'),
        this.$gettext('Sat')
      ]
    }
  },
  watch: {
    updatedDateRangeActive: {
      handler (val) {
        if (val !== 0) {
          this.date_from = this.moment(this.updatedDateRange.startDate)
          this.date_to = this.moment(this.updatedDateRange.endDate)
        } else {
          if (this.tabIndex === 0) {
            this.date_from = this.moment().subtract(6, 'day').startOf('day')
            this.date_to = this.moment().subtract(0, 'day').endOf('day')
          } else {
            this.date_from = this.moment().startOf('day')
            this.date_to = this.moment().endOf('day')
          }
        }
        this.setTimeout()
      },
      deep: true
    },
    companiesCollection(val) {
      if (val.length) {
        this.makeCollectionLink()
      }
    },
    companiesScheduledsCollection(val) {
      if (val.length) {
        this.makeScheduledsCollectionLink()
      }
    },
    companiesFlexesCollection(val) {
      if (val.length) {
        this.makeFlexesCollectionLink()
      }
    },
    companiesNextDaysCollection(val) {
      if (val.length) {
        this.makeNextDaysCollectionLink()
      }
    },
    companiesFlexiblesCollection(val) {
      if (val.length) {
        this.makeFlexiblesCollectionLink()
      }
    },
    allStatuses(val) {
      if (val === true) {
        this.companiesCollection = []
      }
    },
    pendingOnly: 'setTimeout',
    tabIndex(val) {
      if (val === 0) {
        this.resetupdatedDateRange()
      } else {
        this.resetupdatedDateRangeStreet()
      }
      this.setTimeout()
    },
    flexesTypeId(val) {
      if (val.length > 0) {
        this.setTimeout()
      } else {
        clearTimeout(this.intervalSummary)
        clearInterval(this.intervalCountdown)
        this.flexes = []
        this.totalsFlexes = {}
      }
    },
    nextDaysTypeId(val) {
      if (val.length > 0) {
        this.setTimeout()
      } else {
        clearTimeout(this.intervalSummary)
        clearInterval(this.intervalCountdown)
        this.nextDays = []
        this.totalsNextDays = {}
      }
    },
    flexiblesTypeId(val) {
      if (val.length > 0) {
        this.setTimeout()
      } else {
        clearTimeout(this.intervalSummary)
        clearInterval(this.intervalCountdown)
        this.flexibles = []
        this.totalsFlexibles = {}
      }
    },
    filterByCutTime: 'setTimeout',
    workingOnSat: 'setTimeout',
    workingOnSun: 'setTimeout',
    filterWarehouse(val) {
      if (val) {
        this.$cookies.set('warehouse', val)
      } else {
        this.$cookies.remove('warehouse')
      }
      this.setTimeout()
    }
  },
  created() {
    this.filterByOperator = this.$cookies.get('impersonating') || {}
    this.fetchWarehouses()
    this.fetchShippingTypes()
      .then(() => {
        this.flexesTypeId = [this.shippingTypes.find(x => x.name === 'mercado_flex').id]
        this.notFlexesTypeId = this.shippingTypes.filter(x => x.name !== 'mercado_flex').map(x => { return x.id })
        this.nextDaysTypeId = [this.shippingTypes.find(x => x.name === 'next_day').id]
        this.flexiblesTypeId = [this.shippingTypes.find(x => x.name === 'flexible').id]
        this.fetchVehicleTypes()
          .then(() => {
            this.filterWarehouse = this.$cookies.get('warehouse') || null
            this.setTimeout()
          })
      })
  },
  beforeDestroy() {
    clearTimeout(this.intervalSummary)
    clearInterval(this.intervalCountdown)
  },
  methods: {
    setTimeout() {
      clearTimeout(this.intervalSummary)

      this.intervalSummary = setTimeout(function () {
        this.setTimeout()
      }.bind(this), 60000)
      if (this.tabIndex === 0) {
        this.getSummary()
        this.getNeedUrgentAction()
      } else if (this.tabIndex === 1) {
        this.getScheduleds()
      } else if (this.tabIndex === 2) {
        this.getFlexes()
      } else if (this.tabIndex === 3) {
        this.getNextDays()
      } else if (this.tabIndex === 4) {
        this.getFlexibles()
      }
    },
    setIntervalCountdown() {
      clearInterval(this.intervalCountdown)
      this.intervalCountdown = setInterval(function () {
        this.countdown = this.countdown === 0 ? 0 : this.countdown - 1
      }.bind(this), 1000)
    },
    filterPreferences(summary) {
      let response = []
      if (this.$store.getters.profile.meta) {
        let meta
        try {
          meta = JSON.parse(this.$store.getters.profile.meta)
        } catch (e) {
          meta = this.$store.getters.profile.meta
        }
        if (meta.backofficePreferences && meta.backofficePreferences.companies.include.ids.length === 0 && meta.backofficePreferences.companies.exclude.ids.length > 0) {
          response = summary.filter(x => meta.backofficePreferences.companies.exclude.ids.indexOf(x.company_id) === -1)
        } else if (meta.backofficePreferences && meta.backofficePreferences.companies.include.ids.length > 0) {
          response = summary.filter(x => meta.backofficePreferences.companies.include.ids.indexOf(x.company_id) !== -1)
        } else {
          response = summary
        }
      } else {
        response = summary
      }
      return response
    },
    getMeliStalled() {
      this.utcMeliStalledDateFrom = this.moment().tz(this.$tz).clone().subtract(8, 'day').startOf('day')
      this.utcMeliStalledDateTo = this.moment().tz(this.$tz).clone().subtract(1, 'day').endOf('day')

      let params = {
        limit: 1,
        sort: [{
          key: 'updated_at',
          direction: 'asc'
        }],
        filter_groups: [
          {
            filters: [
              [ 'updated_at', 'bt', [this.utcMeliStalledDateFrom.utc().format('YYYY-MM-DD HH:mm:ss'), this.utcMeliStalledDateTo.utc().format('YYYY-MM-DD HH:mm:ss')] ],
              [ 'status', 'in', ['CONFIRMED', 'ATPICKUPPOINT', 'INTRANSIT', 'INCIDENCE'] ],
              [ 'shipping_type_id', 'eq', this.flexesTypeId ]
            ]
          }
        ]
      }

      if (this.$cookies.get('filterOwnCompanies') === 'true') {
        params.filter_groups.push(
          {
            filters: [
              ['company_operators', 'eq', this.$store.getters.profile.id]
            ]
          }
        )
      }
      if (this.$cookies.get('filterOwnCompaniesSls') === 'true') {
        params.filter_groups.push(
          {
            filters: [
              ['company_sellers', 'eq', this.$store.getters.profile.id]
            ]
          }
        )
      }
      if (this.filterByOperator.id) {
        params.filter_groups.push(
          {
            filters: [
              ['company_operators', 'eq', this.filterByOperator.id]
            ]
          }
        )
      }
      if (!this.$cookies.get('bypassCountry')) {
        params.filter_groups.push(
          {
            filters: [
              ['from_country_iso_code', 'eq', window.country]
            ]
          }
        )
      }

      if (this.filterWarehouse) {
        params.filter_groups.push(
          {
            filters: [
              ['from_place_id', 'eq', this.filterWarehouse]
            ]
          }
        )
      }

      this.$http.get(this.$appConfig.api.baseUrl + 'shippings', {params: params})
        .then(response => {
          this.meliStalled = response.body.pagination.total
        })
    },
    getGeneralStalled() {
      this.utcGeneralStalledDateFrom = this.moment().tz(this.$tz).clone().subtract(15, 'day').startOf('day')
      this.utcGeneralStalledDateTo = this.moment().tz(this.$tz).clone().subtract(1, 'day').endOf('day')

      let params = {
        limit: 1,
        sort: [{
          key: 'updated_at',
          direction: 'asc'
        }],
        filter_groups: [
          {
            filters: [
              [ 'updated_at', 'bt', [this.utcGeneralStalledDateFrom.utc().format('YYYY-MM-DD HH:mm:ss'), this.utcGeneralStalledDateTo.utc().format('YYYY-MM-DD HH:mm:ss')] ],
              [ 'status', 'in', ['CONFIRMED', 'ATPICKUPPOINT', 'INTRANSIT', 'INCIDENCE', 'TOBERETURNED'] ],
              [ 'shipping_type_id', 'eq', this.flexesTypeId, 'true' ]
            ]
          }
        ]
      }

      if (this.$cookies.get('filterOwnCompanies') === 'true') {
        params.filter_groups.push(
          {
            filters: [
              ['company_operators', 'eq', this.$store.getters.profile.id]
            ]
          }
        )
      }
      if (this.$cookies.get('filterOwnCompaniesSls') === 'true') {
        params.filter_groups.push(
          {
            filters: [
              ['company_sellers', 'eq', this.$store.getters.profile.id]
            ]
          }
        )
      }
      if (this.filterByOperator.id) {
        params.filter_groups.push(
          {
            filters: [
              ['company_operators', 'eq', this.filterByOperator.id]
            ]
          }
        )
      }
      if (!this.$cookies.get('bypassCountry')) {
        params.filter_groups.push(
          {
            filters: [
              ['from_country_iso_code', 'eq', window.country]
            ]
          }
        )
      }

      if (this.filterWarehouse) {
        params.filter_groups.push(
          {
            filters: [
              ['from_place_id', 'eq', this.filterWarehouse]
            ]
          }
        )
      }

      this.$http.get(this.$appConfig.api.baseUrl + 'shippings', {params: params})
        .then(response => {
          this.generalStalled = response.body.pagination.total
        })
    },
    getNeedUrgentAction() {
      let params = {
        limit: 1,
        includes: [
          'pending_hooks'
        ],
        sort: [{
          key: 'status',
          direction: 'asc'
        }],
        filter_groups: [
          {
            filters: [
              [ 'status', 'eq', 'DRAFT' ],
              [ 'fields_revision', 'eq', 1 ],
              [ 'first_ready_date', 'eq', 'NULL', true ],
              ['created_at', 'gte', this.utcDateFrom.utc().format('YYYY-MM-DD HH:mm:ss')],
              ['created_at', 'lte', this.utcDateTo.utc().format('YYYY-MM-DD HH:mm:ss')]
            ]
          }
        ]
      }

      if (!this.$cookies.get('bypassCountry')) {
        params.filter_groups.push(
          {
            filters: [
              ['from_country_iso_code', 'eq', window.country]
            ]
          }
        )
      }

      if (this.filterWarehouse) {
        params.filter_groups.push(
          {
            filters: [
              ['from_place_id', 'eq', this.filterWarehouse]
            ]
          }
        )
      }

      this.$http.get(this.$appConfig.api.baseUrl + 'shippings', {params: params})
        .then(response => {
          this.needUrgentAction = response.body.pagination.total
        })

      this.getMeliStalled()
      this.getGeneralStalled()
    },
    fetchWorkingCouriers() {
      let params = {
        limit: 1,
        filter_groups: [
          {
            filters: [
              ['created_at', 'gte', this.utcDateFrom.utc().format('YYYY-MM-DD HH:mm:ss')],
              ['created_at', 'lte', this.utcDateTo.utc().format('YYYY-MM-DD HH:mm:ss')]
            ]
          }
        ]
      }
      if (!this.$cookies.get('bypassCountry')) {
        params.filter_groups.push(
          {
            filters: [
              ['user.country_iso_code', 'eq', window.country]
            ]
          }
        )
      }

      this.$http.get(this.$appConfig.api.baseUrl + 'couriers/worked', {params: params})
        .then(response => {
          this.workedCouriers = response.body.pagination.total
        })
    },
    getSummary() {
      this.countdown = 60
      this.setIntervalCountdown()
      this.utcDateFrom = this.date_from.tz(this.$tz).startOf('day').clone()
      this.utcDateTo = this.date_to.tz(this.$tz).endOf('day').clone()

      let params = {
        date_to: this.utcDateTo.utc().format('YYYY-MM-DD'),
        time_to: this.utcDateTo.utc().format('HH:mm:ss'),
        date_from: this.utcDateFrom.utc().format('YYYY-MM-DD'),
        time_from: this.utcDateFrom.utc().format('HH:mm:ss'),
        filter_by: 'updated_at',
        filter_by_cut_time: this.filterByCutTime,
        working_on_sat: this.workingOnSat,
        working_on_sun: this.workingOnSun
      }

      if (this.$cookies.get('filterOwnCompanies') === 'true') {
        params.user_relationship = 'operator'
        params.user_id = this.$store.getters.profile.id
      }

      if (this.$cookies.get('filterOwnCompaniesSls') === 'true') {
        params.user_relationship = 'seller'
        params.user_id = this.$store.getters.profile.id
      }

      if (this.filterByOperator.id) {
        params.user_relationship = 'operator'
        params.user_id = this.filterByOperator.id
      }

      if (!this.$cookies.get('bypassCountry')) {
        params.from_country_iso_code = window.country
      }

      if (this.filterWarehouse) {
        params.from_place_id = this.filterWarehouse
      }

      this.$http.get(this.$appConfig.api.baseUrl + 'shippings/summarize', {params: params})
        .then(response => {
          let summary = response.body
          new Promise(function (resolve, reject) {
            resolve(this.filterPreferences(summary))
          }.bind(this))
            .then(response => {
              this.summary = response

              let statuses = [
                'DRAFT',
                'READYATSTORE',
                'READY',
                'WAITING',
                'CONFIRMED',
                'ATPICKUPPOINT',
                'INTRANSIT',
                'DELIVERED',
                'INCIDENCE',
                'TOBERETURNED',
                'RETURNED',
                'CANCELED'
              ]

              for (let i = 0; i < statuses.length; i++) {
                this.totals[statuses[i]] = this.summary.reduce((total, obj) => (obj.statuses[statuses[i]] || 0) + total, 0)
              }
            })
        })
      this.fetchWorkingCouriers()
      this.minDate = this.moment(JSON.parse(JSON.stringify(this.date_from))).subtract(120, 'days').format('YYYY-MM-DD')
    },
    makeLink(status, companyIds, names) {
      let qs = {
        statuses: ['status', 'in', status],
        types: [],
        scheduleds: [],
        shippingId: [],
        destinationContactName: [],
        destinationAddress: [],
        externalCode: [],
        withoutTour: [],
        company: [],
        courier: [],
        client: [],
        forReview: [],
        createdAtTo: [],
        createdAtFrom: [],
        updatedAtTo: ['updated_at', 'lte', this.date_to.format('YYYY-MM-DD HH:mm:ss')],
        updatedAtFrom: ['updated_at', 'gte', this.date_from.format('YYYY-MM-DD HH:mm:ss')],
        warehouse: this.filterWarehouse ? ['from_place_id', 'eq', this.filterWarehouse] : []
      }
      if (companyIds) {
        qs['company'] = [
          ['company_id', 'in', companyIds],
          names
        ]
      }

      return encodeURIComponent(JSON.stringify(qs))
    },
    makeCollectionLink() {
      let qs = {
        statuses: ['status', 'in', ['DRAFT', 'READY']],
        types: [],
        scheduleds: [],
        shippingId: [],
        destinationContactName: [],
        destinationAddress: [],
        externalCode: [],
        withoutTour: [],
        company: [
          ['company_id', 'in', this.companiesCollection.map(company => {
            return company.company_id
          })],
          this.companiesCollection.map(company => {
            return company.name
          })
        ],
        courier: [],
        client: [],
        forReview: [],
        createdAtTo: [],
        createdAtFrom: [],
        updatedAtTo: ['updated_at', 'lte', this.date_to.endOf('day').format('YYYY-MM-DD HH:mm:ss')],
        updatedAtFrom: ['updated_at', 'gte', this.date_from.startOf('day').format('YYYY-MM-DD HH:mm:ss')],
        warehouse: this.filterWarehouse ? ['from_place_id', 'eq', this.filterWarehouse] : []
      }
      this.collectionQs = encodeURIComponent(JSON.stringify(qs))
    },
    resetupdatedDateRange() {
      this.date_from = this.moment().subtract(6, 'day').startOf('day')
      this.date_to = this.moment().subtract(0, 'day').endOf('day')
      this.updatedDateRange = {
        startDate: this.moment().subtract(6, 'day').startOf('day').toDate(),
        endDate: this.moment().subtract(0, 'day').endOf('day').toDate()
      }
      this.updatedDateRangeActive = 0
    },
    resetupdatedDateRangeStreet() {
      this.date_from = this.moment().startOf('day')
      this.date_to = this.moment().endOf('day')
      this.updatedDateRange = { // used for v-model prop
        startDate: this.moment().startOf('day').toDate(),
        endDate: this.moment().endOf('day').toDate()
      }
      this.updatedDateRangeActive = 0
    },
    updateValues(obj) {
      this.updatedDateRangeActive++
      // console.log(obj)
    },
    getScheduleds() {
      let startDay = this.pendingOnly === false ? this.moment().startOf('day').utc() : this.moment().utc()
      let endDay = this.moment().endOf('day').utc()
      let params = {
        date_to: endDay.format('YYYY-MM-DD'),
        date_from: startDay.format('YYYY-MM-DD'),
        filter_by: 'scheduled_date',
        time_from: startDay.format('HH:mm:ss'),
        time_to: endDay.format('HH:mm:ss')
      }

      if (this.$cookies.get('filterOwnCompanies') === 'true') {
        params.user_relationship = 'operator'
        params.user_id = this.$store.getters.profile.id
      }

      if (this.$cookies.get('filterOwnCompaniesSls') === 'true') {
        params.user_relationship = 'seller'
        params.user_id = this.$store.getters.profile.id
      }

      if (this.filterByOperator.id) {
        params.user_relationship = 'operator'
        params.user_id = this.filterByOperator.id
      }

      if (!this.$cookies.get('bypassCountry')) {
        params.from_country_iso_code = window.country
      }

      if (this.filterWarehouse) {
        params.from_place_id = this.filterWarehouse
      }

      this.$http.get(this.$appConfig.api.baseUrl + 'shippings/summarize', {params: params})
        .then(response => {
          let scheduleds = response.body
          console.log(scheduleds)
          scheduleds = new Promise(function (resolve, reject) {
            resolve(this.filterPreferences(scheduleds))
          }.bind(this))
            .then(response => {
              this.scheduleds = response

              let statuses = [
                'DRAFT',
                'READYATSTORE',
                'READY',
                'WAITING',
                'CONFIRMED',
                'PICKEDUP',
                'INTRANSIT',
                'DELIVERED',
                'INCIDENCE',
                'TOBERETURNED',
                'RETURNED',
                'CANCELED'
              ]

              for (let i = 0; i < statuses.length; i++) {
                this.totalsScheduleds[statuses[i]] = this.scheduleds.reduce((total, obj) => (obj.statuses[statuses[i]] || 0) + total, 0)
              }
            })
          this.countdown = 60
          this.setIntervalCountdown()
        })
    },
    makeScheduledsLink(status, companyIds, names) {
      let qs = {
        statuses: ['status', 'in', status],
        types: [],
        scheduleds: ['scheduled_date', 'gt', this.moment().startOf('day').format('YYYY-MM-DD HH:mm:ss')],
        scheduledsToday: ['scheduled_date', 'lt', this.moment().endOf('day').format('YYYY-MM-DD HH:mm:ss')],
        shippingId: [],
        destinationContactName: [],
        destinationAddress: [],
        externalCode: [],
        withoutTour: [],
        company: [],
        courier: [],
        client: [],
        forReview: [],
        createdAtTo: [],
        createdAtFrom: [],
        updatedAtFrom: [],
        updatedAtTo: [],
        warehouse: this.filterWarehouse ? ['from_place_id', 'eq', this.filterWarehouse] : []
      }
      if (companyIds) {
        qs['company'] = [
          ['company_id', 'in', companyIds],
          names
        ]
      }

      return encodeURIComponent(JSON.stringify(qs))
    },
    makeScheduledsCollectionLink() {
      let qs = {
        statuses: ['status', 'in', ['DRAFT', 'READY']],
        types: [],
        scheduleds: ['scheduled_date', 'gt', this.moment().startOf('day').format('YYYY-MM-DD HH:mm:ss')],
        scheduledsToday: ['scheduled_date', 'lt', this.moment().endOf('day').format('YYYY-MM-DD HH:mm:ss')],
        shippingId: [],
        destinationContactName: [],
        destinationAddress: [],
        externalCode: [],
        withoutTour: [],
        company: [
          ['company_id', 'in', this.companiesScheduledsCollection.map(company => {
            return company.company_id
          })],
          this.companiesScheduledsCollection.map(company => {
            return company.name
          })
        ],
        courier: [],
        client: [],
        forReview: [],
        createdAtTo: [],
        createdAtFrom: [],
        updatedAtFrom: [],
        updatedAtTo: [],
        warehouse: this.filterWarehouse ? ['from_place_id', 'eq', this.filterWarehouse] : []
      }
      this.collectionScheduledsQs = encodeURIComponent(JSON.stringify(qs))
    },
    getFlexes() {
      let flexes = {}
      let params = {
        filter_groups: [
          {
            filters: [
              ['shipping_type_id', 'in', this.flexesTypeId],
              ['status', 'in', ['DRAFT', 'READY']]
            ]
          }
        ],
        includes: ['company']
      }

      params.filter_groups.push(
        {
          filters: [
            ['cutTime', 'lte', 1]
          ]
        }
      )

      if (!this.$cookies.get('bypassCountry')) {
        params.filter_groups.push(
          {
            filters: [
              ['from_country_iso_code', 'eq', window.country]
            ]
          }
        )
      }

      if (this.filterWarehouse) {
        params.filter_groups.push(
          {
            filters: [
              ['from_place_id', 'eq', this.filterWarehouse]
            ]
          }
        )
      }

      this.$http.get(this.$appConfig.api.baseUrl + 'shippings', {params: params})
        .then(response => {
          response.body.data.forEach((item, i) => {
            if (!flexes[item.company.name]) {
              flexes[item.company.name] = {
                name: item.company.name,
                company_id: item.company.id,
                statuses: {
                  [item.status]: 1
                }
              }
            } else {
              if (!flexes[item.company.name].statuses[item.status]) {
                flexes[item.company.name].statuses[item.status] = 1
              } else {
                flexes[item.company.name].statuses[item.status] = flexes[item.company.name].statuses[item.status] + 1
              }
            }
          })

          this.flexes = Object.values(flexes)

          let statuses = [
            'DRAFT',
            'READY'
          ]

          for (let i = 0; i < statuses.length; i++) {
            this.totalsFlexes[statuses[i]] = this.flexes.reduce((total, obj) => (obj.statuses[statuses[i]] || 0) + total, 0)
          }

          this.countdown = 60
          this.setIntervalCountdown()
        })
    },
    makeFlexesLink(status, companyIds, names) {
      let qs = {
        statuses: ['status', 'in', status],
        types: ['shipping_type_id', 'in', this.flexesTypeId],
        scheduleds: [],
        cutTime: ['cutTime', 'lte', 1],
        shippingId: [],
        destinationContactName: [],
        destinationAddress: [],
        externalCode: [],
        withoutTour: [],
        company: [],
        courier: [],
        client: [],
        forReview: [],
        createdAtTo: [],
        createdAtFrom: [],
        updatedAtFrom: [],
        updatedAtTo: [],
        warehouse: this.filterWarehouse ? ['from_place_id', 'eq', this.filterWarehouse] : []
      }
      if (companyIds) {
        qs['company'] = [
          ['company_id', 'in', companyIds],
          names
        ]
      }

      return encodeURIComponent(JSON.stringify(qs))
    },
    makeFlexesCollectionLink() {
      let qs = {
        statuses: ['status', 'in', ['DRAFT', 'READY']],
        types: ['shipping_type_id', 'in', this.flexesTypeId],
        scheduleds: [],
        cutTime: ['cutTime', 'lte', 1],
        shippingId: [],
        destinationContactName: [],
        destinationAddress: [],
        externalCode: [],
        withoutTour: [],
        company: [
          ['company_id', 'in', this.companiesFlexesCollection.map(company => {
            return company.company_id
          })],
          this.companiesFlexesCollection.map(company => {
            return company.name
          })
        ],
        courier: [],
        client: [],
        forReview: [],
        createdAtTo: [],
        createdAtFrom: [],
        updatedAtFrom: [],
        updatedAtTo: [],
        warehouse: this.filterWarehouse ? ['from_place_id', 'eq', this.filterWarehouse] : []
      }
      this.collectionFlexesQs = encodeURIComponent(JSON.stringify(qs))
    },
    getNextDays() {
      let nextDays = {}

      let params = {
        filter_groups: [
          {
            filters: [
              ['shipping_type_id', 'in', this.nextDaysTypeId],
              ['status', 'in', ['READY', 'ATPICKUPPOINT', 'INTRANSIT', 'INCIDENCE']],
              ['sla_date', 'eq', this.moment.utc().tz(this.$tz).add(1, 'day').format('YYYY-MM-DD')]
            ]
          }
        ],
        includes: ['company']
      }

      if (!this.$cookies.get('bypassCountry')) {
        params.filter_groups.push(
          {
            filters: [
              ['from_country_iso_code', 'eq', window.country]
            ]
          }
        )
      }

      if (this.filterWarehouse) {
        params.filter_groups.push(
          {
            filters: [
              ['from_place_id', 'eq', this.filterWarehouse]
            ]
          }
        )
      }

      this.$http.get(this.$appConfig.api.baseUrl + 'shippings', {params: params})
        .then(response => {
          response.body.data.forEach((item, i) => {
            if (!nextDays[item.company.name]) {
              nextDays[item.company.name] = {
                name: item.company.name,
                company_id: item.company.id,
                statuses: {
                  [item.status]: 1
                }
              }
            } else {
              if (!nextDays[item.company.name].statuses[item.status]) {
                nextDays[item.company.name].statuses[item.status] = 1
              } else {
                nextDays[item.company.name].statuses[item.status] = nextDays[item.company.name].statuses[item.status] + 1
              }
            }
          })

          this.nextDays = Object.values(nextDays)

          let statuses = [
            'READY',
            'ATPICKUPPOINT',
            'INTRANSIT',
            'INCIDENCE'
          ]

          for (let i = 0; i < statuses.length; i++) {
            this.totalsNextDays[statuses[i]] = this.nextDays.reduce((total, obj) => (obj.statuses[statuses[i]] || 0) + total, 0)
          }

          this.countdown = 60
          this.setIntervalCountdown()
        })
    },
    makeNextDaysLink(status, companyIds, names) {
      let qs = {
        statuses: [],
        types: ['shipping_type_id', 'in', this.nextDaysTypeId],
        scheduleds: [],
        cutTime: [],
        shippingId: [],
        destinationContactName: [],
        destinationAddress: [],
        externalCode: [],
        withoutTour: [],
        company: [],
        courier: [],
        client: [],
        forReview: [],
        createdAtTo: [],
        createdAtFrom: [],
        updatedAtFrom: [],
        updatedAtTo: [],
        warehouse: this.filterWarehouse ? ['from_place_id', 'eq', this.filterWarehouse] : [],
        sla: ['tomorrow']
      }
      if (companyIds) {
        qs['company'] = [
          ['company_id', 'in', companyIds],
          names
        ]
      }

      return encodeURIComponent(JSON.stringify(qs))
    },
    makeNextDaysCollectionLink() {
      let qs = {
        statuses: [],
        types: ['shipping_type_id', 'in', this.nextDaysTypeId],
        scheduleds: [],
        cutTime: [],
        shippingId: [],
        destinationContactName: [],
        destinationAddress: [],
        externalCode: [],
        withoutTour: [],
        company: [
          ['company_id', 'in', this.companiesNextDaysCollection.map(company => {
            return company.company_id
          })],
          this.companiesNextDaysCollection.map(company => {
            return company.name
          })
        ],
        courier: [],
        client: [],
        forReview: [],
        createdAtTo: [],
        createdAtFrom: [],
        updatedAtFrom: [],
        updatedAtTo: [],
        warehouse: this.filterWarehouse ? ['from_place_id', 'eq', this.filterWarehouse] : [],
        sla: ['tomorrow']
      }

      this.collectionNextDaysQs = encodeURIComponent(JSON.stringify(qs))
    },
    getFlexibles() {
      let flexibles = {}

      let params = {
        filter_groups: [
          {
            filters: [
              ['shipping_type_id', 'in', this.flexiblesTypeId],
              ['status', 'in', ['READY', 'WAITING', 'CONFIRMED', 'ATPICKUPPOINT', 'INTRANSIT', 'DELIVERED', 'INCIDENCE']],
              ['created_at', 'bt', [this.date_from.startOf('day').tz(this.$tz).utc().format('YYYY-MM-DD HH:mm:ss'), this.date_to.endOf('day').tz(this.$tz).utc().format('YYYY-MM-DD HH:mm:ss')]]
            ]
          }
        ],
        includes: ['company']
      }

      if (!this.$cookies.get('bypassCountry')) {
        params.filter_groups.push(
          {
            filters: [
              ['from_country_iso_code', 'eq', window.country]
            ]
          }
        )
      }

      this.$http.get(this.$appConfig.api.baseUrl + 'shippings', {params: params})
        .then(response => {
          response.body.data.forEach((item, i) => {
            if (!flexibles[item.company.name]) {
              flexibles[item.company.name] = {
                name: item.company.name,
                company_id: item.company.id,
                statuses: {
                  [item.status]: 1
                }
              }
            } else {
              if (!flexibles[item.company.name].statuses[item.status]) {
                flexibles[item.company.name].statuses[item.status] = 1
              } else {
                flexibles[item.company.name].statuses[item.status] = flexibles[item.company.name].statuses[item.status] + 1
              }
            }
          })

          this.flexibles = Object.values(flexibles)

          let statuses = [
            'READY',
            'WAITING',
            'CONFIRMED',
            'ATPICKUPPOINT',
            'INTRANSIT',
            'DELIVERED',
            'INCIDENCE'
          ]

          for (let i = 0; i < statuses.length; i++) {
            this.totalsFlexibles[statuses[i]] = this.flexibles.reduce((total, obj) => (obj.statuses[statuses[i]] || 0) + total, 0)
          }

          this.countdown = 60
          this.setIntervalCountdown()
        })
    },
    makeFlexiblesLink(status, companyIds, names) {
      let qs = {
        statuses: ['status', 'in', status],
        types: ['shipping_type_id', 'in', this.flexiblesTypeId],
        scheduleds: [],
        cutTime: [],
        shippingId: [],
        destinationContactName: [],
        destinationAddress: [],
        externalCode: [],
        withoutTour: [],
        company: [],
        courier: [],
        client: [],
        forReview: [],
        createdAtTo: ['created_at', 'lte', this.date_to.format('YYYY-MM-DD HH:mm:ss')],
        createdAtFrom: ['created_at', 'gte', this.date_from.format('YYYY-MM-DD HH:mm:ss')],
        updatedAtFrom: [],
        updatedAtTo: [],
        warehouse: this.filterWarehouse ? ['from_place_id', 'eq', this.filterWarehouse] : [],
        sla: []
      }
      if (companyIds) {
        qs['company'] = [
          ['company_id', 'in', companyIds],
          names
        ]
      }

      return encodeURIComponent(JSON.stringify(qs))
    },
    makeFlexiblesCollectionLink() {
      let qs = {
        statuses: [],
        types: ['shipping_type_id', 'in', this.flexiblesTypeId],
        scheduleds: [],
        cutTime: [],
        shippingId: [],
        destinationContactName: [],
        destinationAddress: [],
        externalCode: [],
        withoutTour: [],
        company: [
          ['company_id', 'in', this.companiesFlexiblesCollection.map(company => {
            return company.company_id
          })],
          this.companiesFlexiblesCollection.map(company => {
            return company.name
          })
        ],
        courier: [],
        client: [],
        forReview: [],
        createdAtTo: ['created_at', 'lte', this.date_to.format('YYYY-MM-DD HH:mm:ss')],
        createdAtFrom: ['created_at', 'gte', this.date_from.format('YYYY-MM-DD HH:mm:ss')],
        updatedAtFrom: [],
        updatedAtTo: [],
        warehouse: this.filterWarehouse ? ['from_place_id', 'eq', this.filterWarehouse] : [],
        sla: []
      }

      this.collectionFlexiblesQs = encodeURIComponent(JSON.stringify(qs))
    }
  }
}
</script>

<style lang="scss">
.big {
  font-size: 13px;
}
</style>
